import { gql } from "apollo-boost";

// Fetch list of redeem transactions with filters and pagination
export const GET_REDEEMS = gql`
  query Redeems($where: RedeemWhereInput, $skip: Int, $limit: Int, $orderBy: OrderByInput) {
    redeems(where: $where, skip: $skip, limit: $limit, orderBy: $orderBy) {
      total
      data {
        id
        rewardName
        rewardType
        no
        status
        point
        dateYmd
        percent
        shop {
          name
        }
        userConfirm {
          name
          lastname
          phone
        }
        reward {
          name
        }
        orderGroup {
          id
          phone
          code
        }
        createdBy {
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
    }
  }
`;